import { spatialValues, spatialValuesInRem, SpatialOption } from './spatialValues';
import { spatialSquareInset } from './spatialSquareInset';
import { spatialStretchInset } from './spatialStretchInset';
import { spatialSquishInset } from './spatialSquishInset';
import { spatialStack } from './spatialStack';

export { SpatialOption };
/**
 * A collection of variables that will assist in maintaining consistent
 * spacing bewtween elements.
 */
export namespace space {
  export const values = {
    toRem: spatialValuesInRem,
    toPx: spatialValues
  };

  export const squareInset = spatialSquareInset;
  export const stretchInset = spatialStretchInset;
  export const squishInset = spatialSquishInset;

  /**
   * The overwhelming majority of UI is scrolled vertically. To achieve vertical rhythm, we will aim to
   * uniformly space components in a vertical structure.
   *
   * **Usage**: Applied to a `columns` component in a layout, message on a heading, to whatever is stacked.
   * `margin: spatialStack.default`
   */
  export const stack = spatialStack;
}
